import React, { useEffect } from "react";
import "./ContactUs_card.css";
import { Backtotop, Floatinmenu, Underline } from "..";
import { FaEnvelope, FaPhoneAlt } from "react-icons/fa"; // ✅ from react-icons
import { incubation_contact, incubation_menu } from "../../constants/incubation";
import { RadialMenu } from "../../components";

const ContactUs_card = ({ email, phone, heading }) => {
  return (
    <>
      <Underline heading={heading} />

      <div className="contactus-container">
        <div className="contactus-card">
          <div className="contactus-icon-text">
            <div className="icon-box email">
              <FaEnvelope size={22} />
            </div>
            <div className="text-box">
              <h3>Email</h3>
              <a href={`mailto:${email}`}>{email}</a>
            </div>
          </div>

          <div className="contactus-icon-text">
            <div className="icon-box phone">
              <FaPhoneAlt size={22} />
            </div>
            <div className="text-box">
              <h3>Phone</h3>
              <a href={`tel:${phone}`}>{phone}</a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUs_card;
